import React, { useState } from "react"
import PropTypes from "prop-types"

import { connect } from "react-redux"

import { Link } from "react-router-dom"
// reactstrap
// import { Row, Col, Dropdown, DropdownToggle, DropdownMenu, Container } from "reactstrap";

// Import menuDropdown
// import LanguageDropdown from "../CommonForBoth/TopbarDropdown/LanguageDropdown";
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown"
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu"
import WhatsAppQRModal from "../CommonForBoth/TopbarDropdown/WhatsAppQRModal"
import { BsQrCode } from "react-icons/bs"

import jobLogo from "../../assets/images/logo.jpg"
import mainLogo from "../../assets/images/siddhi_full_hd.png"

// import Css
import "../../assets/css/Layout/Header.css"
import Configs from "../../config"

const Header = props => {
  const [isSearch, setSearch] = useState(false)
  const [qrModal, setQrModal] = useState(false)

  // const [socialDrp, setsocialDrp] = useState(false);

  return (
    <React.Fragment>
      <header id="page-topbar" className="Header">
        <div className="navbar-header px-0">
          <div className="d-flex">
            <div className="navbar-brand-box">
              <Link to={`${Configs.appurl}`} className="logo">
                <span>
                  <img
                    src={mainLogo}
                    alt="JobFitMeter logo"
                    className="job-logo object-fit-cover"
                    height="60"
                  />
                </span>
              </Link>
            </div>
          </div>

          <div className="d-flex">
            {/* <div className="dropdown d-inline-block d-lg-none ms-2">
              <button
                type="button"
                className="btn header-item noti-icon "
                id="page-header-search-dropdown"
                onClick={() => setSearch(!isSearch)}
              >
                <i className="mdi mdi-magnify" />
              </button>
              <div
                className={
                  isSearch
                    ? "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show"
                    : "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                }
                aria-labelledby="page-header-search-dropdown"
              >
                <form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder={props.t("Search") + "..."}
                        aria-label="Recipient's username"
                      />
                      <div className="input-group-append">
                        <button className="btn btn-primary" type="submit">
                          <i className="mdi mdi-magnify" />
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div> */}

            {/* Dropdowns */}
            <div>
              {/* <div className="dropdown d-inline-block">
              <button
                onClick={() => {
                  props.showRightSidebarAction(!props.showRightSidebar);
                }}
                type="button"
                className="btn header-item noti-icon right-bar-toggle "
              >
                <i className="bx bx-cog bx-spin" />
              </button>
            </div> */}

              {/* <LanguageDropdown /> */}

              {/* <Dropdown
              className="d-none d-lg-inline-block ms-1"
              isOpen={socialDrp}
              toggle={() => {
                setsocialDrp(!socialDrp);
              }}
            >
              <DropdownToggle
                className="btn header-item noti-icon "
                caret
                tag="button"
              >
                <i className="bx bx-customize" />
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-lg dropdown-menu-end">
                <div className="px-lg-2">
                  <Row className="no-gutters">
                    <Col>
                      <Link className="dropdown-icon-item" to="#">
                        <img src={github} alt="Github" />
                        <span>GitHub</span>
                      </Link>
                    </Col>
                    <Col>
                      <Link className="dropdown-icon-item" to="#">
                        <img src={bitbucket} alt="bitbucket" />
                        <span>Bitbucket</span>
                      </Link>
                    </Col>
                    <Col>
                      <Link className="dropdown-icon-item" to="#">
                        <img src={dribbble} alt="dribbble" />
                        <span>Dribbble</span>
                      </Link>
                    </Col>
                  </Row>
                  <Row className="no-gutters">
                    <Col>
                      <Link className="dropdown-icon-item" to="#">
                        <img src={dropbox} alt="dropbox" />
                        <span>Dropbox</span>
                      </Link>
                    </Col>
                    <Col>
                      <Link className="dropdown-icon-item" to="#">
                        <img src={mail_chimp} alt="mail_chimp" />
                        <span>Mail Chimp</span>
                      </Link>
                    </Col>
                    <Col>
                      <Link className="dropdown-icon-item" to="#">
                        <img src={slack} alt="slack" />
                        <span>Slack</span>
                      </Link>
                    </Col>
                  </Row>
                </div>
              </DropdownMenu>
            </Dropdown> */}

              {/* <div className="dropdown d-none d-lg-inline-block ms-1">
              <button
                type="button"
                className="btn header-item noti-icon "
                onClick={() => {
                  toggleFullscreen();
                }}
                data-toggle="fullscreen"
              >
                <i className="bx bx-fullscreen" />
              </button>
            </div> */}

              {/* Knowledge base Dropdown */}
              {/* <Dropdown
                className="ms-2"
                isOpen={kbase}
                toggle={() => setKbase(!kbase)}
              >
                <DropdownToggle
                  className="btn header-item "
                  caret
                  tag="button"
                >
                <i className="fas fa-adjust" />  { props.t("Knowledge Base")}
                </DropdownToggle>
                <DropdownMenu className="" >
                      <Row>
                        <Col>
                          <ul className="list-unstyled megamenu-list mb-0">
                            <li>
                              <Link className="dropdown-item" to="#">{props.t(" Knowledge base 1")}</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="#">{props.t(" Knowledge base 2")}</Link>
                            </li>
                          </ul>
                        </Col>
                      </Row>
                </DropdownMenu>
              </Dropdown> */}

              {/* Gantt Chart */}
              {/* <Dropdown
                className="ms-2"
                isOpen={gchart}
                toggle={() => setGchart(!gchart)}
              >
                <DropdownToggle
                  className="btn header-item "
                  caret
                  tag="button"
                >
                <i class="fa-solid fa-chart-simple"></i>  {props.t("Gantt Chart")}
                </DropdownToggle>
                <DropdownMenu className="" >
                      <Row>
                        <Col>
                          <ul className="list-unstyled megamenu-list mb-0">
                            <li>
                              <Link className="dropdown-item" to="#">{props.t("Gantt Chart 1")}</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="#">{props.t("Gantt Chart 2")}</Link>
                            </li>
                          </ul>
                        </Col>
                      </Row>
                </DropdownMenu>
              </Dropdown> */}

              {/* setting Dropdown */}
              {/* <Dropdown
                className="ms-2"
                isOpen={settingMenu}
                toggle={() => setSettingMenu(!settingMenu)}
              >
                <DropdownToggle
                  className="btn header-item "
                  caret
                  tag="button"
                >
                  {props.t("Setting")} <i className="mdi mdi-chevron-down" />
                </DropdownToggle>
                <DropdownMenu className="" >
                      <Row>
                        <Col>
                          <ul className="list-unstyled megamenu-list mb-0">
                            <li>
                              <Link className="dropdown-item" to="#">{props.t("Settings 1")}</Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to="#">{props.t("Settings 2")}</Link>
                            </li>
                          </ul>
                        </Col>
                      </Row>
                </DropdownMenu>
              </Dropdown> */}
            </div>

            {/* <button
              type="button"
              className="btn header-item noti-icon"
              onClick={() => setQrModal(true)}
              title="WhatsApp QR"
            >
              <BsQrCode size={20} />
            </button> */}

            <ProfileMenu />
            <NotificationDropdown />
          </div>
        </div>
      </header>

      <WhatsAppQRModal
        isOpen={qrModal}
        toggle={() => setQrModal(false)}
      />
    </React.Fragment>
  )
}

Header.propTypes = {
  leftMenu: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
}

export default Header
